import { createContext, ReactNode, useContext } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { OrganizationSchema, WebsiteSchema } from '@/components/seo';

interface LayoutProps {
  children: ReactNode;
}

const SharedLayoutContext = createContext(false);

export function Layout({ children }: LayoutProps) {
  const alreadyInsideLayout = useContext(SharedLayoutContext);
  if (alreadyInsideLayout) return <>{children}</>;
  return (
    <SharedLayoutContext.Provider value={true}>
    <div className="min-h-screen flex flex-col">
      {/* Global SEO Schemas */}
      <OrganizationSchema />
      <WebsiteSchema />
      
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
    </SharedLayoutContext.Provider>
  );
}
